import { Usuarios } from "./usuarios/pt-br";

export const br = {
  USUARIOS: {
    ...Usuarios,
  },
  TITULO: "Portal Base Lyncas",
  GERAL: {
    SALVAR: "Salvar",
    SUCCESSO: "Sucesso",
    CANCELAR: "Fechar",
    ERRO: "Erro",
    EMAIL: "E-mail",
    LOGIN: "Login",
    SENHA: "Senha",
    NOVO: "Inserir",
    ACOES: "Ações",
    EDITAR: "Editar",
    TIPO: "Tipo",
    EXCLUIR: "Excluir",
    DUPLICAR: "Duplicar",
    ATENCAO: "ATENÇÃO",
    SIM: "Sim",
    CNPJ_EMPRESA: "CNPJ da Empresa",
    EMPRESA: "Empresa",
    SELECIONAR: "Selecionar Logo",
    NAO: "Não",
    CONFIRMAR: "Confirmar",
    MENSAGEM_CONFIRMAR_ACAO: "Tem certeza que deseja executar esta ação?",
    UM_ARQUIVO: "Envie apenas um arquivo.",
    ACESSO: "Acesso",
    PORTUGUES: "Português",
    INGLES: "English",
    DATA_OBRIGACAO: "Data da Obrigação",
    DATA_PAGAMENTO: "Data de Pagamento",
    SAIR: "Sair",
    CADASTRAR: "Cadastrar",
    ADICIONAR: "Adicionar",
    CONFIRMACAO_SENHA: "Confirmação de Senha",
    OK: "Ok",
    SENHA_ATUAL: "Senha Atual",
    TROCAR_SENHA: "Trocar Senha",
    NOME_ARQUIVO: "Nome Arquivo",
    NOVA_SENHA: "Nova Senha",
    CONFIRMAR_NOVA_SENHA: "Confirmar Nova Senha",
    SENHA_ALTERADA: "Senha Alterada com Sucesso",
    ESQUECEU_SENHA: "Esqueceu sua senha?",
    EMAIL_ENVIADO: "E-mail enviado com sucesso!",
    REDEFINIR_SENHA: "Redefinir senha",
    VOLTAR_LOGIN: "Voltar ao Login",
    USUARIO: "Usuário",
    ENTRAR: "Entrar",
    SAIBA_MAIS: "Saiba mais",
    PAGINACAO: "Mostrar todos",
    POR_PAGINA: "Mostrar",
    PAGINA_PRINCIPAL_TITULO: "Receba à vista pelo que você vendeu a prazo!",
    PAGINA_PRINCIPAL_MSG: "A antecipação de recebíveis é uma escolha inteligente e\neficaz porque você usa um dinheiro que já pertence à sua empresa",
    MINHA_CONTA: "Minha Conta",
    PERFIL: "Perfil",
    CONFIGURACOES: "Configurações",
    CONFIRMAR_EXCLUIR_PERFIL: "Tem certeza que deseja excluir este perfil?",
    SISTEMA_GESTAO_MSG: "SISTEMA DE GESTÃO DO PROGRAMA DE P&D DA ANEEL",
    ARRASTE: "Arrastar Logo",
    DESCRICAO: "Descrição",
    CONFIRMAR_EXCLUIR: "Tem certeza que deseja excluir este item?",
    MENSAGEM_EXCLUIDO: "Item excluído com sucesso!",
    MENSAGEM_CADASTRADO: "Item salvo com sucesso!"
  },
  LOGIN: {
    NAO_TEM_CONTA: "Não tem uma conta?",
    CADASTRAR_USUARIO: "Cadastrar Usuário?",
    ESQUECEU_SENHA: "Esqueceu sua senha?",
    ENTRAR: "Entrar",
    FACA_LOGIN: "Faça login em sua conta",
  },
  TABELA_DOCUMENTOS:{
    ESPECIFICACOES: 'Especificações',
    NOME_ARQUIVO: 'Nome Arquivo',
    DESCRICAO: 'Descrição',
    DETALHAMENTO: 'Detalhamento',
    BAIXAR: 'Baixar',
  },
  MENU: {
    PERFIS: "Perfis",
    PAINEL: "Painel de Controle",
    PESSOAS: "Pessoas",
    EMPRESAS: "Empresas",
    LISTA_EMPRESAS: "Lista de Empresas",
    CONFIGURACOES: "Configurações",
    ARMAZENAMENTO: "Armazenamento",
    USUARIOS: "Usuários",
    DOCUMENTOS: "Documentos",
    APROVACAO_USUARIOS: "Aprovação de Usuário",
    TERMOS: "Termos de uso e politica de privacidade",
    FORMULARIO_DEMANDA : "Formulário de Demanda",
    DEMANDA : "Demanda",
  },
  PESSOAS:{
    MENSAGEM_EXCLUIDO: "Pessoa excluída com sucesso.",
    MENSAGEM_CADASTRADO: "Pessoa cadastrada com sucesso.",
    CONFIRMAR_EXCLUIR: "Tem certeza que deseja excluir {nome}?"
  },
  AUDITORIA: {},
  EMPRESAS: {
    CONFIRMAR_EXCLUIR_EMPRESA: "Tem certeza que deseja excluir esta empresa?",
    RAZAO_SOCIAL: "Razão Social",
    NOME_FANTASIA: "Nome Fantasia",
    FAX: "FAX",
    LISTA_EMPRESAS: "Lista de Empresas",
    MENSAGEM_CADASTRADO: "Empresa cadastrada com sucesso!",
    MENSAGEM_EXCLUIDO: "Empresa excluída com sucesso!",
    MENSAGEM_SALVADA: "As informações foram salvas com sucesso!",
    CODIGO_ANEEL: "Código ANEEL",
    CLASSIFICACAO: "Classificação",
    SEGMENTO: "Segmento",
    NOME: "Empresa",
    TIPO : "Tipo",
    TELEFONE: "Telefone",
    EMAIL: "E-mail",
    CIDADE: "Cidade",
    UF: "UF",
    ACESSO: "Acesso",
    EMPRESAS_RELACIONADAS: "Empresas Relacionadas",
    SELECIONAR_EMPRESA: "Selecionar",
    FILTRO_MODAL: "Buscas empresas",
    ASSOCIAR_SUCESSO: "Empresa associada com sucesso!",
  },
  OPERACOES: {},
  PERMISSOES: {
    NOME: "Nome",
    ACESSOS: "Acessos",
    ACESSO: "Acesso",
    PERMISSAO: "Permissões",
    VIZUALIZAR: "Visualizar",
    MENSAGEM_CADASTRADO: "Perfil cadastrado com sucesso!",
    CRIAR: "Criar",
    EDITAR: "Editar",
    EXCLUIR: "Excluir",
  },
  CAMPOS_VALIDACAO: {
    INVALIDO: "O campo {{name}} é inválido",
    REQUERIDO: "Por favor informe o campo {{name}}",
    MASCARA: "Por favor informe o conteudo correto conforme a mascara do campo {{name}}",
    TAMANHO: "O campo {{name}} precisa possuir {{length}} caracteres",
    TAMANHO_MINIMO: "O campo {{name}} precisa possuir no mínimo {{min}} caracteres",
    TERMOS_CONDICOES: "É necessário aceitar os termos e condições",
    NAO_ENCONTRADO: "O usuário {{name}} não foi encontrado",
    LOGIN_INVALIDO: "Login inválido",
    CAMPO_REQUERIDO: "Campo requerido",
    COMPIMENTO_MINIMO: "Comprimento mínimo do campo de {{length}} caracteres",
    COMPRIMENTO_MAXIMO: "Comprimento máximo do campo de {{length}} caracteres",
    VALOR_MINIMO: "Valor mínimo do campo de é {{min}}",
    VALOR_MAXIMO: "Valor máximo do campo de é {{max}}",
    CAMPO_INVALIDO: "Campo não é válido",
    SENHA_E_CONFIRMACAO: "As senhas digitadas não são iguais",
  },
  PLACEHOLDER: {
    EMAIL: "Digite seu e-mail",
    SENHA: "Digite sua senha",
    NOME_USUARIO: "Ex: João da Silva",
    VALOR: "Ex: Operação",
    ID_ENTIDADE: "Ex: XYZ",
    SELECIONE: "Selecione",
  },
};
